import { defineComponent } from "vue";
import ChatItem, { AbstractChatItem } from "../ChatItem";

export interface ChatItemHello extends AbstractChatItem {
    text: string;
}

export default defineComponent({
    components: {
        ChatItem,
    },

    template: `
        <ChatItem
            :class="'ChatItem--info-' + item.type"
            :kind="item.kind"
            :author="item.author"
            :content="item.message"
            :date="item.date"
        />
    `,

    props: {
        item: { type: Object, required: true },
    },
});
